<script setup>
const props = defineProps({
    active: { type: Boolean },
    tabs: {
        type: Array,
        default: () => [],
        validator(tabs) {
            return tabs.every((tab) => tab.id && tab.label);
        },
    },
});

const emit = defineEmits(['changeTab']);

// TODO refactor to either use model or emit changeTab event only
function toggleTab(tabToToggle) {
    if (tabToToggle.active) return;

    props.tabs.forEach((tab) => {
        tab.active = false;
    });
    tabToToggle.active = true;

    emit('changeTab', tabToToggle);
}
</script>

<template>
    <div class="m-tabNav">
        <ul
            v-if="active"
            class="m-tabNav__tabList"
        >
            <li
                v-for="tab in tabs"
                :key="tab.id"
                class="m-tabNav__tab"
                :data-id="tab.id"
            >
                <button
                    class="m-tabNav__label"
                    :aria-label="`${tab.label} Reiter`"
                    :class="{ 'm-tabNav__label--active': tab.active }"
                    :data-ga-event="tab.event"
                    @click="toggleTab(tab)"
                >
                    <span
                        class="m-tabNav__labelText"
                        :class="{ 'm-tabNav__labelText--active': tab.active }"
                    >
                        {{ tab.label }}
                    </span>
                    <div
                        v-if="tab.hasBranding"
                        class="m-tabNav__pills"
                    >
                        <span class="m-tabNav__pill">Einblicke</span>
                        <span
                            v-if="tab.isBrandingSolution"
                            class="m-tabNav__pill m-tabNav__pill--brandingSolution"
                        >Videos</span>
                    </div>
                </button>
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
@use "styles";
</style>
